import {TherapyUnit} from "@/models/schedulerEvent";

export default class Patient {
    public id?: number;
    public name?: string;
    public surname?: string;
    public therapyUnits?: Array<TherapyUnit>

    constructor({
                    id,
                    name,
                    surname,
                    therapyUnits
                }: any) {
        this.id = id;
        this.name = name;
        this.surname = surname;
        this.therapyUnits = therapyUnits != undefined ? therapyUnits : [];
    }
}

export class WritePatient {
    public id?: number;
    public periodId?: number;
    public therapyUnits?: Array<WriteTherapyUnit>;

    constructor(id?: number, periodId?: number, therapyUnits?: Array<WriteTherapyUnit>) {
        this.id = id;
        this.periodId = periodId;
        this.therapyUnits = therapyUnits;
    }
}

export class WriteTherapyUnit {
    public activity?: number;
    public weeklyNumber?: number;
    public duration?: number;
    public preferredTherapist?: number;

    constructor({activity, weeklyNumber, duration, preferredTherapist}: any) {
        this.activity = activity;
        this.weeklyNumber = weeklyNumber;
        this.duration = duration != null ? duration / 15 : 0;
        this.preferredTherapist = preferredTherapist;
    }

}
